import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './BannerManagement.css'; // Reusing similar styles

const StoreManagement = () => {
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingStore, setEditingStore] = useState(null);
    const [formData, setFormData] = useState({
        nome: '',
        logoUrl: '',
        domainPattern: '',
        color: '#000000',
        textColor: '#ffffff'
    });
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        fetchStores();
    }, []);

    const fetchStores = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/lojas`);
            setStores(response.data);
        } catch (error) {
            console.error('Erro ao buscar lojas:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formDataUpload = new FormData();
        formDataUpload.append('logo', file); // Changed from 'image' to 'logo'

        setUploading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/upload/logo1`, formDataUpload, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setFormData(prev => ({ ...prev, logoUrl: response.data.imageUrl }));
        } catch (error) {
            console.error('Erro no upload:', error);
            alert('Erro ao fazer upload da imagem');
        } finally {
            setUploading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingStore) {
                await axios.put(`http://localhost:5001/api/lojas/${editingStore.id}`, formData);
                alert('Loja atualizada com sucesso!');
            } else {
                await axios.post('http://localhost:5001/api/lojas', formData);
                alert('Loja criada com sucesso!');
            }
            setEditingStore(null);
            setFormData({ nome: '', logoUrl: '', domainPattern: '', color: '#000000', textColor: '#ffffff' });
            fetchStores();
        } catch (error) {
            console.error('Erro ao salvar loja:', error);
            alert('Erro ao salvar loja');
        }
    };

    const handleEdit = (store) => {
        console.log('Editando loja:', store);
        setEditingStore(store);
        setFormData({
            nome: store.nome || '',
            logoUrl: store.logoUrl || '',
            domainPattern: store.domainPattern || '',
            color: store.color || '#000000',
            textColor: store.textColor || '#ffffff'
        });
    };

    const handleDelete = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir esta loja?')) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL}/lojas/${id}`);
                fetchStores();
            } catch (error) {
                console.error('Erro ao excluir loja:', error);
            }
        }
    };

    const handleCancel = () => {
        setEditingStore(null);
        setFormData({ nome: '', logoUrl: '', domainPattern: '', color: '#000000', textColor: '#ffffff' });
    };

    if (loading) return <div>Carregando...</div>;

    return (
        <div className="banner-management-container">
            <h2 className="page-title">Gerenciamento de Lojas</h2>

            <div className="banner-form-card">
                <h3>{editingStore ? 'Editar Loja' : 'Nova Loja'}</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Nome da Loja</label>
                        <input
                            type="text"
                            name="nome"
                            value={formData.nome}
                            onChange={handleInputChange}
                            required
                            placeholder="Ex: Amazon"
                        />
                    </div>

                    <div className="form-group">
                        <label>Padrão de Domínio (para detecção automática)</label>
                        <input
                            type="text"
                            name="domainPattern"
                            value={formData.domainPattern}
                            onChange={handleInputChange}
                            placeholder="Ex: amazon.com|amzn.to"
                            required
                        />
                        <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
                            Use | para separar múltiplos domínios. O sistema buscará esses textos no link do produto.
                        </small>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Cor Principal</label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="color"
                                    name="color"
                                    value={formData.color}
                                    onChange={handleInputChange}
                                    style={{ width: '50px', height: '40px', padding: '0', border: 'none' }}
                                />
                                <span>{formData.color}</span>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Cor do Texto</label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="color"
                                    name="textColor"
                                    value={formData.textColor}
                                    onChange={handleInputChange}
                                    style={{ width: '50px', height: '40px', padding: '0', border: 'none' }}
                                />
                                <span>{formData.textColor}</span>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Logo da Loja</label>
                        <div className="image-upload-container">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageUpload}
                                id="logo-upload"
                                style={{ display: 'none' }}
                            />
                            <label htmlFor="logo-upload" className="upload-button">
                                <i className="fas fa-cloud-upload-alt"></i>
                                {uploading ? 'Enviando...' : 'Escolher Logo'}
                            </label>

                            {formData.logoUrl && (
                                <div className="image-preview" style={{ marginTop: '10px', backgroundColor: '#f0f0f0', padding: '10px', borderRadius: '8px', display: 'inline-block' }}>
                                    <img src={formData.logoUrl} alt="Preview" style={{ height: '60px', objectFit: 'contain' }} />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="form-actions">
                        {editingStore && (
                            <button type="button" className="cancel-button" onClick={handleCancel}>
                                Cancelar
                            </button>
                        )}
                        <button type="submit" className="submit-button" disabled={uploading}>
                            {editingStore ? 'Atualizar Loja' : 'Criar Loja'}
                        </button>
                    </div>
                </form>
            </div>

            <div className="banners-list">
                <h3>Lojas Cadastradas</h3>
                <div className="banners-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
                    {stores.map((store) => (
                        <div key={store.id} className="banner-card" style={{ borderTop: `4px solid ${store.color}` }}>
                            <div className="banner-preview" style={{ height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa' }}>
                                <img src={store.logoUrl} alt={store.nome} style={{ maxHeight: '80%', maxWidth: '80%', objectFit: 'contain' }} />
                            </div>
                            <div className="banner-info">
                                <h4>{store.nome}</h4>
                                <p style={{ fontSize: '12px', color: '#666' }}>Domínios: {store.domainPattern}</p>
                                <div className="banner-actions">
                                    <button onClick={() => handleEdit(store)} className="edit-button">
                                        <i className="fas fa-edit"></i> Editar
                                    </button>
                                    <button onClick={() => handleDelete(store.id)} className="delete-button">
                                        <i className="fas fa-trash"></i> Excluir
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StoreManagement;
